import { render, staticRenderFns } from "./DiseaseGis.vue?vue&type=template&id=08542fe6"
import script from "./DiseaseGis.vue?vue&type=script&lang=js"
export * from "./DiseaseGis.vue?vue&type=script&lang=js"
import style0 from "./DiseaseGis.vue?vue&type=style&index=0&id=08542fe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports